export default "__VITE_ASSET__CT4h89oF__"